import PlacementsPage from "./PlacementsPage";

export default PlacementsPage;